import VariablesTable from "./VariablesTable";
export default VariablesTable;
